import { RmaChatModelMf, NewDetailsRmaModelMf, NewEquipmentModelMf, RmaDetailModelMf, RmaModelMf, RmaResultMf, RmaFilterModelMf, RmaModelLiteMf } from 'models';
import { AddItemInCartModelMf, CreatNewRmaModelMf, CreatNewRmaModelCAMf, CreatNewRmaModelCATestMf, ItemsCartMf, ResultMf, RmaChatTableMf } from 'models/rmamanufatura/detailsRma';
import { atom } from 'recoil';
import { persistAtom } from './persistanceAtom';
import { ModelEOSMf, ModelEOSEditMf, ModelEOSResultMf } from 'models/rmamanufatura/eosModel';

export const newEquipamentState = atom({
    key: 'newEquipament',
    default: [new NewEquipmentModelMf()]
});

export const newDetailsRmaState = atom({
    key: 'newDetailsRma',
    default: [new NewDetailsRmaModelMf()]
});

export const rmaState = atom({
    key: 'rma',
    default: new RmaResultMf(),
    effects_UNSTABLE: [persistAtom]
});

export const rmaDetailState = atom({
    key: 'rmaDetailState',
    default: null as unknown as RmaDetailModelMf
});

export const messageModel = atom({
    key: 'rmaMessageModel',
    default: null as unknown as RmaChatModelMf
});

export const AddItemCartState = atom({
    key: 'newRmaState',
    default: null as unknown as AddItemInCartModelMf
});

export const ItemInCart = atom({
    key: 'ItemInCart',
    default: null as unknown as ItemsCartMf
});

export const ItemsCartAdd = atom({
    key: 'ItemsCartModelAdd',
    default: null as unknown as ItemsCartMf[]
});

export const CreatNewRma = atom({
    key: 'CreatNewRmas',
    default: null as unknown as CreatNewRmaModelMf
});
export const ChatRma = atom({
    key: 'ChatRma',
    default: null as unknown as RmaChatTableMf[]
});

export const CreateNewRmaCA = atom({
    key: 'CreatNewRmaCA',
    default: null as unknown as CreatNewRmaModelCAMf
});

export const CreateNewRmaCATest = atom({
    key: 'CreatNewRmaCATest',
    default: null as unknown as CreatNewRmaModelCATestMf
});

export const RmaItems = atom({
    key: 'CreatNewRmasCA',
    default: null as unknown as ResultMf
});

export const Rma = atom({
    key: 'RmaModel',
    default: null as unknown as RmaModelMf
});

export const RmaLiteMf = atom({
    key: 'RmaModelLiteMf',
    default: null as unknown as RmaModelLiteMf
});

export const EosAtom = atom({
    key: 'EosAtom',
    default: null as unknown as ModelEOSResultMf[]
})

export const EosListAtom = atom({
    key: 'EosListAtom',
    default: null as unknown as ModelEOSMf[]
})

export const FilterAtom = atom({
    key: 'FilterAtom',
    default: null as unknown as RmaFilterModelMf
});
export const RMAFileAtom = atom({
    key: 'RMAFileAtom',
    default: null as unknown as File|null
});

// export const RmaItemCA = atom({
//     key: 'CreatNewItemCA',
//     default: null as unknown as RmaItemsCA
// })